import React from "react";
import {
  AppProvider,
  AlertProvider,
  DialogProvider,
  NotificationsProvider,
  AuthProvider,
} from "./hooks";
import { AppRouting } from "./routers";
import "./Theme.less";
import { ConfigProvider } from 'antd';
import esES from 'antd/lib/locale/es_ES';
import moment from "moment";
moment.locale("es");

const App = () => (
  <ConfigProvider locale={esES}>
  <AppProvider>
    <AlertProvider>
      <DialogProvider>
        <NotificationsProvider>
          <AuthProvider>
            <AppRouting />
          </AuthProvider>
        </NotificationsProvider>
      </DialogProvider>
    </AlertProvider>
  </AppProvider>
  </ConfigProvider>

);

export default App;
